import { ArrowDownOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useInfoUser } from "../../../store/UserStore";
import { useChatContext } from "../../../context/ChatContext";

export const NewMessage = () => {
  const { languageMap } = useInfoUser();
  const { isNewMessage, isScrollToLastMessage, comeToLastMessage, scrollToBottom } =
    useChatContext();

  if (isNewMessage) {
    return (
      <div className="bottom-scroll-shortcut">
        <Button
          className="text-[#005ae0] flex items-center shake-animation"
          onClick={comeToLastMessage}
        >
          <ArrowDownOutlined />
          {languageMap?.["message.scroll.newMessage"] ?? "New message"}
        </Button>
      </div>
    );
  }

  return (
    <div
      className={`${isScrollToLastMessage ? "bottom-scroll-shortcut" : "hidden"}`}
    >
      <Button
        className="bg-[#7f91b8] text-[white] scroll-button"
        icon={<ArrowDownOutlined />}
        onClick={scrollToBottom}
      />
    </div>
  );
};
